// extracted by mini-css-extract-plugin
export default {"message":"NFRUSH9AyWf9rahIyB2s","wrapper":"tuEIUOWAFusbtlLmpZhK"};